import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '../session/session.service'; // Assuming SessionService holds user role
import { UserType } from 'sp-client'; // Import UserType

export const roleRedirectGuard: CanActivateFn = (_route, _state) => {
  const sessionService = inject(SessionService);
  const router = inject(Router);

  // Assuming SessionService has a signal or method to get the current user's role
  // and a way to check if the user is a super admin.
  // For example, if sessionService.currentUser().isSuperAdmin is true
  // or sessionService.hasRole('super-admin') is true.
  // Adjust the condition based on your actual SessionService implementation.
  const currentUser = sessionService.user();
  const isSuperAdmin = currentUser?.user_type_id === UserType.SuperAdmin;

  if (isSuperAdmin) {
    router.navigate(['/super-admin/tenants']);
    return false; // Prevent activation of the current route
  }

  return true; // Allow activation for non-super-admins
}; 